export default (str: string): string => {
  str = str || '';
  str = str.toLowerCase();
  return str.replace(/(_|-| )/g, '');
};
